// Cards named in text (recaps, the journal), drawn there as the card itself: CardRef(card) for a card everyone can
// see (shown as in hand, hover for the card), HiddenRef(age) for one face down (its back). The client turns them into
// pictures (see IconText); elsewhere CardRefText reads them as plain words.
const CardToData = require('./Converters/CardToData');

// (with the card's version, for a card the expansion changed: see Constants/CardVersions.js)
const CardRef = (card) => {
    const data = CardToData(card) ?? { type: card.type, name: card.name, age: card.age, version: card.version };
    return `⟦c:${data.type}|${data.name}|${data.age}${data.version ? `|${data.version}` : ''}⟧`;
};

const HiddenRef = (age) => `⟦b:${age}⟧`;

// A card face down to everyone but its owner (a player number), e.g. a military card discarded from their hand: the
// server shows it to each viewer as one or the other (ForViewer)
const OwnedRef = (card, owner) => `⟦h:${owner}:${CardRef(card).slice('⟦c:'.length, -1)}⟧`;
const OwnedPattern = /⟦h:(\d+):([^⟧]*)⟧/g;
const ForViewer = (text, viewer) => typeof text !== 'string' ? text : text.replace(OwnedPattern,
    (_, owner, body) => Number(owner) === viewer ? `⟦c:${body}⟧` : HiddenRef(body.split('|')[2]));

// The pattern, and as plain text: a card its name, a face-down one "an Age I card"
const CardRefPattern = /⟦(c|b):([^⟧]*)⟧/g;
const CardRefText = (text) => typeof text !== 'string' ? text : ForViewer(text, null).replace(CardRefPattern,
    (_, kind, body) => kind === 'b' ? `an ${body} card` : body.split('|')[1]);

module.exports = { CardRef, HiddenRef, OwnedRef, ForViewer, CardRefPattern, CardRefText };
